<template>
  <div class="login-wrapper">
    <div class="login-content">
      <div class="login-iframe">
        <login-common/>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import loginCommon from '@/components/assist/login/common'
export default {
  components: {
    loginCommon
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.login-wrapper {
  height: 650px;
  min-height: 440px;
  background: linear-gradient(
    -60deg,
    rgb(91, 169, 255) 0%,
    rgb(221, 244, 255) 100%
  );
  .login-content {
    background: url(../../../../static/assist/login_bg.png) no-repeat left
      center;
    width: 1200px;
    margin: 0 auto;
    height: inherit;
    min-height: inherit;
    position: relative;
  }
  .login-iframe {
    width: 450px;
    height: 440px;
    position: absolute;
    right: 0;
    top: 50%;
    //为了居中
    margin-top: -220px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assist/login/index.vue